import React from 'react';
import PageComponent from './Page';

const Prototype = ({
  nextClickHandler,
  onAnalyseResultsClick,
  menuItems,
  selectComponent,
  componentIndex,
  rules,
  backPath,
  onDone,
  test,
  locales,
  locales: {
    testing: {
      name,
      titles,
      testPlan: {
        header,
        prototype: { text, title, footer, cardTitle, rate },
      },
    },
  },
}) => {
  return (
    <PageComponent
      cardName={cardTitle}
      handlers={[onAnalyseResultsClick ?? nextClickHandler, onDone]}
      title={title}
      locales={locales}
      text={text}
      name={name}
      footer={footer}
      header={header}
      stars={rate}
      test={test}
      titles={titles}
      menuItems={menuItems}
      selectComponent={selectComponent}
      componentIndex={componentIndex}
      rules={rules}
      backPath={backPath}
    />
  );
};

export default Prototype;
